import { createCardTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Card Component Configuration
 * Content containers with shadow
 */
export function createCard(s: SemanticTokens) {
  const cardTokens = createCardTokens(s);
  return {
  root: {
    background: cardTokens.bg,
    borderRadius: cardTokens.base.radius,
    color: cardTokens.fg,
    shadow: 'none',
  },
  body: {
    padding: '0',
    gap: '0',
  },
  caption: {
    gap: '0',
  },
  title: {
    fontSize: cardTokens.title.fontSize,
    fontWeight: cardTokens.title.fontWeight,
  },
  subtitle: {
    color: cardTokens.subtitleFg,
  },
  colorScheme: {
    light: {
      root: {
        background: cardTokens.bg,
        color: cardTokens.fg,
      },
      subtitle: {
        color: cardTokens.subtitleFg,
      },
    },
  },
  css: () => `
    .p-card {
      border: none;
      overflow: visible;
    }

    .p-card-body {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .p-card-header {
      margin: 0;
      border-radius: 0;
      gap: ${cardTokens.headerGap};
    }

    .p-card-header img {
      display: block;
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    .p-card-title {
      font-family: ${cardTokens.base.fontFamily};
      line-height: ${cardTokens.title.lineHeight};
      margin: 0;
    }

    .p-card-subtitle {
      font-family: ${cardTokens.base.fontFamily};
      font-size: ${cardTokens.subtitle.fontSize};
      line-height: ${cardTokens.subtitle.lineHeight};
      margin: 0;
    }

    .p-card-content {
      height: 100%;
      padding: 0;
      margin: 0;
      font-family: ${cardTokens.base.fontFamily};
      font-size: ${cardTokens.contentText.fontSize};
      line-height: ${cardTokens.contentText.lineHeight};
      display: flex;
      flex-direction: column;
      border-radius: ${cardTokens.base.radius};
    }

    .p-card-footer {
      padding: 0;
      margin: 0;
    }
  `,
  };
}
export const card = createCard(SEMANTIC);